import {Component, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar} from '@angular/material';
import * as moment from 'moment-timezone';
import { IVideoHistoryRequestApiParams } from 'app/_models/tracker';
import { environment } from 'environments/environment';
import { APIsettings } from 'app/app.config';
import { VideoHistoryService } from 'app/_services/video-history.service';
import { GeneralDialog } from '../GeneralDialog/general-dialog';

export interface IVideoRequestData {
  vehicleID: number,
  minDate: any,
  maxDate: any,
  isLiveRequest: boolean;
}

/**
 * @title Dialog for video requests on the video activity page
 */

@Component({
  selector: 'video-request-dialog',
  templateUrl: 'video-request-dialog.html',
})
export class VideoRequestDialog {

  public chosenDateTime = '';
  public chosenDuration = 30;

  public minDatetime = '';
  public maxDatetime = '';
  public minDuration: number = 30;
  public maxDuration: number = 120;
  public isLiveVideoRequest = false;

  private zone:any;

  formatLabel(value: number) {
    if (value >= 1000) {
      return Math.round(value / 1000) + 'seconds';
    }

    return value;
  }

  constructor(
    public dialogRef: MatDialogRef<VideoRequestDialog>,

    @Inject(MAT_DIALOG_DATA) public data: IVideoRequestData) {
      if (data && data.maxDate) {
        const prefs = JSON.parse(localStorage.getItem('currentUser')).user.prefs;
        this.zone = prefs.time_zone || moment.tz.guess();

        console.log(data.minDate);
        this.convertDataDates();

        this.chosenDateTime = moment.tz(data.minDate, this.zone).format('YYYY-MM-DDTHH:mm');

        this.minDatetime = moment.tz(data.minDate, this.zone).format('YYYY-MM-DDTHH:mm');
        this.maxDatetime = moment.tz(data.maxDate, this.zone).format('YYYY-MM-DDTHH:mm');
        console.log(this.minDatetime, this.maxDatetime);
      }
      this.isLiveVideoRequest = data.isLiveRequest;
      if (this.isLiveVideoRequest) {
        this.minDuration = 0;
        this.maxDuration = 30;
        this.chosenDuration = 15;
      }
  }

  convertDataDates() {
    // this.data.minDate = moment(data.minDate);
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  dateTimeChange(e) {
    console.log(e);
  }

  async onDone() {

      
    this.dialogRef.close({
      start: moment.tz(this.chosenDateTime, this.zone).utc(),
      duration: this.chosenDuration,
      vehicle: this.data.vehicleID,
    });
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Dialogs/VideoRequestDialog/video-request-dialog.ts